var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"container-fluid custom-footer fixed-bottom"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',{staticClass:"text-green"},[_vm._v("DYG Digital")]),_vm._v(" © Chile 2023. Todos los derechos reservados ")])])])
}]

export { render, staticRenderFns }